import React from 'react';
import { reportSecurityError } from '../utilities/securityErrorReporter';
import { useTranslate } from '../hooks/LanguageProvider';

function Fallback() {
  const { translate } = useTranslate();
  return <div className="container-fluid"><div className="card"><div className="card-body" role="alert">
    <h4>{translate('Page unavailable')}</h4><p>{translate('An unexpected page error occurred')}</p>
    <button className="btn btn-outline-secondary" onClick={()=>window.location.reload()}>{translate('Reload page')}</button>
  </div></div></div>;
}
export default class SecurityErrorBoundary extends React.Component<{children:React.ReactNode},{failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  componentDidCatch(error:Error){reportSecurityError('react_error',error);}
  render(){return this.state.failed ? <Fallback/> : this.props.children;}
}
